import Vue from 'vue'
import App from './App.vue'
import VueSignature from "vue-signature-pad";
import 'jquery'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './registerServiceWorker'
import 'videojs-youtube/dist/Youtube.min.js'
import AudioRecorder from 'vue-audio-recorder'
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSignature);

Vue.use(VueSimpleAlert);
Vue.use(AudioRecorder)
import VueSession from 'vue-session'
import axios from 'axios'
import UUID from 'vue-uuid'
import router from './router'
import store from './store'
import VueSweetalert2 from 'vue-sweetalert2';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
import helpers from './helpers/utils';

Vue.prototype.$response = []
Vue.prototype.$results = []
Vue.use(VueSession)
Vue.use(UUID)
Vue.use({
  install() {
      Vue.helpers = helpers;
      Vue.prototype.$helpers = helpers;
  }
});
Vue.use(VueSweetalert2);

Vue.config.productionTip = false
global.event = new Vue();
Vue.use(require('vue-moment'));
Vue.prototype.$isWebDevice = true;
if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  Vue.prototype.$isWebDevice = false;
}

new Vue({
  router,
  store,
  axios,
  render: h => h(App),
  mounted () {
    window.addEventListener(
      "message",
      (event) => {
        if(event.data.send_height) {
          let height = document.getElementById('main_component_wraper').clientHeight;
          parent.postMessage({height:height}, '*')
        }
        if(event.data.canary_load_url) {
          Vue.prototype.$canary_load_url = event.data.canary_load_url;
        }
      },
      false
    );
    global.event.$on('height_change', (height)=>{
      let previousHeight = this.$session.get("height");
      if(height !== previousHeight) {
        // console.log(previousHeight)
        // console.log(height)
        parent.postMessage({height:height}, '*');
      }
      this.$session.set("height", height);
    });
    global.event.$on('update_root_color', ()=>{
      let background_color =  this.$session.get("response").settings.background_color;
      let accent_color =  this.$session.get("response").settings.accent_color;
      let title_color =  this.$session.get("response").settings.title_color;
      let launcher_btn_color =  this.$session.get("response").settings.button_color;
      let action_button_color =  this.$session.get("response").settings.action_button_color;
      let launcher_btn_background_color =  this.$session.get("response").settings.button_background_color;
      var r = document.querySelector(':root');
      r.style.setProperty('--accent-color', accent_color);
      r.style.setProperty('--background-color', background_color);
      r.style.setProperty('--title-color', title_color);
      r.style.setProperty('--launcher-btn-background-color', launcher_btn_background_color);
      r.style.setProperty('--launcher-btn-color', launcher_btn_color);
      r.style.setProperty('--action-btn-color', action_button_color);
      document.body.style.backgroundColor = background_color;
    })
  }
}).$mount('#app')
